/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cafe': {
    width: 110,
    height: 79,
    viewBox: '0 0 110 79',
    data: '<path pid="0" d="M17.368 0c-3.206 0-5.788 2.517-5.788 5.641v50.785c0 3.124 2.582 5.642 5.788 5.642h63.684c3.206 0 5.788-2.518 5.788-5.642v-5.641h2.896c2.896 0 2.896-2.823 2.896-2.823v-2.823h5.788c5.788 0 11.58-5.641 11.58-11.286V16.929c0-2.823-2.896-5.642-5.792-5.642l-17.368-.004V5.642C86.84 2.513 84.257 0 81.052 0H17.368zm69.471 16.928h14.477c2.891 0 2.891 2.823 2.891 2.823v14.105c0 2.823-2.891 5.642-5.788 5.642H86.84v-22.57zM0 67.713l8.684 8.464C10.119 77.577 11.58 79 14.472 79h69.471c2.892 0 4.349-1.416 5.788-2.823l8.684-8.464H0z" _fill="#2B363B"/>'
  }
})
